const configService = {
  baseURL: process.env.REACT_APP_API_URL,
  facebookId: process.env.REACT_APP_FACEBOOK_APP_ID,
  googleMapApiKey: process.env.REACT_APP_GOOGLE_MAP_APP_KEY,
  googleLoginApiKey: process.env.REACT_APP_GOOGLE_APP_ID,
  stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
  timeout: 120000,
  maxImageSize: 10 * 1024 * 1024,
};

export { configService };
